<nz-list *ngIf="!listWebhook()" [nzDataSource]="[]"></nz-list>

<div class="w-full border rounded-lg p-4">
  <form *ngIf="listWebhook()" [formGroup]="formGroupWebhook">
    <div class="form-group flex flex-col col-12">
      <label for="url">Webhook URL:</label>
      <div class="col-12 flex flex-col">
        <nz-input-group
          nzSize="large"
          [nzSuffix]="suffixTemplate"
          [nzStatus]="isValidURL() ? '' : 'error'"
        >
          <input
            nz-input
            nzSize="large"
            formControlName="url"
            placeholder="Enter the URL where webhook notifications will be sent"
            (keydown.enter)="$event.preventDefault()"
            (input)="setValueRuleWebhook()"
          />
        </nz-input-group>
        <ng-template #suffixTemplate>
          <img
            *ngIf="listWebhook()"
            src="https://storage.googleapis.com/komerce/assets/icons/edit.svg"
            alt="edit"
            width="20px"
            style="cursor: pointer"
            [ngStyle]="{ opacity: isEditMode() ? '0.5' : '1' }"
            (click)="toggleEdit()"
          />
        </ng-template>
      </div>
      <span class="text-xs text-gray-500 mt-1"
        >Enter the URL where webhook notifications will be sent</span
      >
    </div>

    <div class="mt-1 flex items-center col-12">
      <span class="text-danger flex items-center gap-2">
        <img
          *ngIf="errPN() !== ''"
          src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
          alt="warning"
          style="max-width: 10px; max-height: 10px"
        />
        {{ errPN() }}
      </span>
    </div>
  </form>

  <div class="mt-3 flex justify-end">
    <button
      *ngIf="!listWebhook()"
      class="btn btn-primary text-white"
      (click)="addWebhook()"
    >
      Add Webhook URL
    </button>

    <button
      *ngIf="listWebhook()"
      class="btn"
      style="width: 154px"
      [ngClass]="
        isSaveDisabled() ? 'btn-outline-secondary' : 'btn-primary text-white'
      "
      [disabled]="isSaveDisabled()"
      (click)="submit()"
    >
      Save
    </button>
  </div>
</div>

<div *ngIf="!isGetWebhook()" class="overlay flex items-center justify-center">
  <nz-card
    style="width: 500px"
    nzHoverable
    class="flex flex-col items-center text-center p-4"
  >
    <div class="flex flex-col items-center gap-2">
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
        alt="warning"
        width="90px"
      />
      <h6 class="text-bold mt-3" style="font-size: 20px">
        This Feature is for Enterprise Users Only
      </h6>
    </div>
    <span>
      To access advanced shipping features, upgrade to our Enterprise Package —
      designed for businesses that need more control, faster delivery
      management, and premium support.
    </span>
    <div class="flex items-center gap-3 w-full">
      <button
        class="btn btn-primary text-white w-100 mt-3 text-nowrap"
        (click)="upgradeToEnterprise()"
      >
        <small>Upgrade to Enterprise</small>
      </button>
    </div>
  </nz-card>
</div>
